import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { PDMLink } from './pages/PDMLink';
import { ProjectLink } from './pages/ProjectLink';
import { SupplierManagement } from './pages/SupplierManagement';
import { CreoView } from './pages/CreoView';
import { Infrastructure } from './pages/Infrastructure';
import { Customization } from './pages/Customization';
import { Upgrades } from './pages/Upgrades';
import { Toaster } from './components/ui/sonner';

export function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hire-pdmlink-customization-expert" element={<PDMLink />} />
        <Route path="/hire-projectlink-customization-expert" element={<ProjectLink />} />
        <Route path="/hire-supplier-management-expert" element={<SupplierManagement />} />
        <Route path="/hire-creo-view-visualization-expert" element={<CreoView />} />
        <Route path="/hire-infrastructure-customization-expert" element={<Infrastructure />} />
        <Route path="/hire-windchill-customization-expert" element={<Customization />} />
        <Route path="/hire-windchill-upgrade-expert" element={<Upgrades />} />
      </Routes>
      <Footer />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
